export default __webpack_public_path__ + "static/media/content.ba270fcb.png";